import { render, staticRenderFns } from "./InicisComponent.vue?vue&type=template&id=1dc1044e&"
import script from "./InicisComponent.vue?vue&type=script&lang=js&"
export * from "./InicisComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports